(function () {
  function initHeroCarousel(root) {
    var track = root.querySelector('.tm-hero-track');
    var slides = root.querySelectorAll('.tm-hero-slide');
    var dots = root.querySelectorAll('.tm-hero-dot');
    if (!track || !slides.length) return;

    var index = 0;
    var total = slides.length;
    var interval = parseInt(root.getAttribute('data-autoplay-interval'), 10) || 6000;
    var timer = null;

    function goTo(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
    }

    function next() { goTo(index + 1); }

    function play() {
      stop();
      timer = window.setInterval(next, interval);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () {
        goTo(di);
        play();
      });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', play);

    goTo(0);
    play();
  }

  function init() {
    document.querySelectorAll('[data-tm-hero-carousel]').forEach(initHeroCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
